import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=fb766e64&scoped=true"
import script from "./activityPage.vue?vue&type=script&lang=js"
export * from "./activityPage.vue?vue&type=script&lang=js"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=fb766e64&prod&scoped=true&lang=css"
import style1 from "./activityPage.vue?vue&type=style&index=1&id=fb766e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb766e64",
  null
  
)

export default component.exports